import { render } from "./ViewRecord.vue?vue&type=template&id=da4fe102&scoped=true"
import script from "./ViewRecord.vue?vue&type=script&lang=js"
export * from "./ViewRecord.vue?vue&type=script&lang=js"

import "./ViewRecord.vue?vue&type=style&index=0&id=da4fe102&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da4fe102"]])

export default __exports__